import { render, staticRenderFns } from "./freezes.vue?vue&type=template&id=41266f50&scoped=true&"
import script from "./freezes.vue?vue&type=script&lang=js&"
export * from "./freezes.vue?vue&type=script&lang=js&"
import style0 from "./freezes.vue?vue&type=style&index=0&id=41266f50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41266f50",
  null
  
)

export default component.exports